import { Component, OnInit } from '@angular/core';
import { VivoService } from '../vivo.service';
import { SidebarService } from '../../shared/sidebar/sidebar.service';
import { AppMessageService } from '../../shared/app-message/app-message.service';
import { LandingPageTile } from '../../shared/tiles/home-tile.model';
import { SidebarPanelComponent } from '../../sidebar/sidebar-panel/sidebar-panel.component';
import { _ } from '../../shared/utils';
import { forEach } from 'lodash-es';
import { isAfter } from 'date-fns/esm';
import { Filters, Property, VivoBody, VivoChangeEvent } from '../../sidebar/vivo-filters/vivo-filters.model';

@Component({
  selector: 'qm-vivo-maintenance',
  templateUrl: './vivo-maintenance.component.html',
  styleUrls: ['./vivo-maintenance.component.scss']
})
export class VivoMaintenanceComponent extends SidebarPanelComponent implements OnInit {
  // TOTALLY STUPID VARIABLES WHICH ARE MADE JUST FOR TRANSLATIONS ASD
  asd1: string = _('pending');
  asd2: string = _('completed');
  asd3: string = _('All');

  public events: any[] = [];
  public comments: Map<string, any> = new Map();
  public activeId: string;
  public tasks: {name: string, value: string}[] = [];
  public vivoBody: VivoBody = new VivoBody();
  public pagination: any;

  public noResults: boolean = false;

  public commentText: string = null;

  constructor(private vivoService: VivoService,
              protected sidebarService: SidebarService,
              protected appMessageService: AppMessageService
  ) {
    super(appMessageService, sidebarService);
    this.componentName = VivoMaintenanceComponent.getComponentName();
  }

  public static initTile(tile: LandingPageTile) {
    tile.description = _('Maintenances');
    tile.icon = 'far fa-tasks';
    tile.title = _('Maintenances');
    tile.panel = VivoMaintenanceComponent.getComponentName();
  }
  private static getComponentName(): string {
    return 'VivoMaintenances';
  }

  ngOnInit() {
    this.prepareFilters();
  }

  public filtersChanged($event: VivoChangeEvent) {
    if ($event) {
      this.vivoBody = $event.vivoBody;
      this.prepareMaintenanceList();
    }
  }

  private async prepareFilters() {
    const results = await this.vivoService.vivoTaskType();
    forEach(await results.docs, (o: any) => {
      if (o.id !== this.vivoService.getDiaryTaskType()) {
        this.tasks.push({name: o.name, value: o.id});
      }
    });
    this.getBody();
  }

  private async prepareMaintenanceList() {
    this.events = [];
    const prepResponses = await Promise.all([
      this.vivoService.getVivoTasks(this.vivoBody)
    ]);
    if (prepResponses[0].docs < 1) {
      this.noResults = true;
    } else {
      this.noResults = false;
    }
    this.pagination = prepResponses[0];
    forEach(prepResponses[0].docs, async (o: any) => {
      // this.getComments(o._id);
      this.events.push(o);
    });
    console.log('hmmm this.events', this.events);
  }

  public async getComments(id: string) {
    const temp: any = await this.vivoService.getCommentsForTask(id);
    if (temp.docs.length > 0) {
      this.comments.set(id, temp.docs);
    }
  }

  public getNames(names: any): string[] {
    const results: string[] = [];
    for (const single of names) {
      const name = single.name.split(' ');
      results.push(name[0].split('')[0] + name[1].split('')[0]);
    }
    return results;
  }

  public saveComment(id: string, message: string) {
    if (id && message) {
      const body = {
        eventData: {
          contentData: message,
          contentID: id,
          contentType: 'Task',
          type: 'newComment'
        }
      };
      this.commentText = null;
      this.vivoService.createComment(body);
      this.prepareMaintenanceList();
    }
  }

  /**
   * setActive sets activeId which is used to indentify notification from list where mouse is on top of it
   * @param {Notification} type
   */
  public setActive(com: any) {
    if (this.activeId === com.id) {
      this.activeId = null;
    } else {
      this.activeId = com.id;
    }
  }

  /**
   * isActive return true/false depending which notification mouse is hovering on
   * @param {Notification} type
   */
  public isActive(com: any) {
    if (com.id === this.activeId) {
      return true;
    }
    return false;
  }

  public getTaskLink(id: number): string {
    return 'https://miprovivo.trackinno.com/tasks/' + id;
  }

  public getColor(name: number): string {
    switch (name) {
      case 1:
        return 'critical';
      case 2:
        return 'important';
      case 3:
        return 'green';
    }
  }

  private getBody(): any {
    this.vivoBody = new VivoBody();
    const property: Property = {
      label: 'taskType',
      _id: 'taskType',
      type: 'taskType'
    };
    const value: {_id: string}[] = [];
    for (const single of this.tasks) {
      if (single.value !== this.vivoService.getDiaryTaskType()) {
        value.push({_id: single.value});
      }
    }
    const removeDiary = {
      property: {
        label: 'taskType',
        _id: 'taskType',
        type: 'taskType'
      },
      option: {
        value: 'notequals'
      },
      value: [
        {
          _id: this.vivoService.getDiaryTaskType()
        }
      ]
    };
    this.vivoBody.filters.push({property, value});
    this.vivoBody.filters.push(removeDiary);
    this.vivoBody.viewOptions = {
      orderby: 'updatedAt',
      reverse: true
    };
    this.prepareMaintenanceList();
  }

  pageChanged(event: any): void {
    if (this.vivoBody.page !== event) {
      this.vivoBody.page = event;
      this.prepareMaintenanceList();
    }
  }

  assetTree(asset: any): string[] {
    const result: string[] = [];
    if (asset && asset.asset && asset.asset.name) {
      result.push(asset.asset.name);
      if (asset.asset.holder.parentAsset) {
        result.push(asset.asset.holder.parentAsset.name + ' > ');
        result.push(asset.asset.holder.parentAsset.holder.name + ' > ');
      } else if (asset.asset.holder.parent) {
        result.push(asset.asset.holder.name + ' > ');
        result.push(asset.asset.holder.parent.name + ' > ');
      } else {
        result.push(asset.asset.holder.name + ' > ');
      }
      return result.reverse();
    }
    return result;
  }
}
